import { render } from "./CreateProductView.vue?vue&type=template&id=17dbaa9a&scoped=true&ts=true"
import script from "./CreateProductView.vue?vue&type=script&lang=ts"
export * from "./CreateProductView.vue?vue&type=script&lang=ts"

import "./CreateProductView.vue?vue&type=style&index=0&id=17dbaa9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17dbaa9a"]])

export default __exports__